import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SucheComponent } from './suche/suche.component';
import { ErgebnisComponent } from './ergebnis/ergebnis.component';
import { BefreiungRoutingModule } from './befreiung-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BefreiungRoutingModule,
    HttpClientModule
  ],
  declarations: [
    SucheComponent,
    ErgebnisComponent
  ],
  providers: [
  ]
})
export class BefreiungModule { }



// WEBPACK FOOTER //
// ./src/app/befreiung/befreiung.module.ts